import {
	Component,
	OnInit,
	Input,

} from '@angular/core';

// import $ from 'jquery';
import { NbSpinnerService } from '@nebular/theme';
import { KragUtilitiesService } from '../../@core/utils/krag-utilities.service';
// Import the Cloudinary classes.
import {Cloudinary, CloudinaryImage} from '@cloudinary/url-gen';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'm-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

	public hostname = window.location.hostname;
	public host = window.location.host;
	public logoImgURL!: CloudinaryImage;
	public footerLogo!: CloudinaryImage;
	public bgImgURL;
	@Input() action = 'login';
	today: number = Date.now();

	constructor(
		private spinner : NbSpinnerService,
		private utilSvc: KragUtilitiesService,
	) {}

	ngOnInit(): void {
		this.spinner.load();
		// $(document).ready(function() {
		// 	$('#welcomediv').delay(2000).fadeIn(400);
		// 	$('#welcomediv2').delay(2000).fadeIn(400);
		// 	$('#logindiv').delay(2000).fadeIn(450);
		// });

    	this.bgImgURL = this.getBackgroundImageURL();

    // Create a Cloudinary instance and set cloud name.
    const cld = new Cloudinary({
      cloud: {
        cloudName: environment.cloud_name,
      },
    });

    // Instantiate a CloudinaryImage object for the image with the public ID.
    this.logoImgURL = cld.image(this.getLogoImg());
    this.footerLogo = cld.image("Login/kragworks_logo");
  }

	public getLogoImg() : string{
		return 'Login/' + this.utilSvc.getSubdomain() + "_logo";
	}

	public getBackgroundImageURL() : string{
		return 'https://res.cloudinary.com/kragworks/image/upload/Login/' + this.utilSvc.getSubdomain() + "_bg.jpg";
	}
}
